import {
    REQUEST_USERS,
    RECEIVE_USERS,
    UPDATE_USERS,
    ERROR_USERS
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_USERS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_USERS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case UPDATE_USERS:
            const data = state.data
            let index = null
            switch(action.updateType) {
                case 'create':
                    data.results.push(action.payload)
                    break
                case 'update':
                    if(data.results){
                        index = data.results.findIndex(item => item.id == action.id)
                        data.results[index] = action.payload
                    }
                    break
                case 'delete':
                    index = data.results.findIndex(item => item.id == action.id)
                    data.results.splice(index, 1)
                    break
            }
            return {
                ...state,
                isFetching: false,
                data,
                errors: action.errors
            }
        case ERROR_USERS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}